<template>
  <d2-container>
    <template slot="header">
      <div class="app-container calendar-list-container">
        <div class="filter-container">
          <el-input size="small" @keyup.enter.native="handleFilter" style="width: 300px;margin-right: 10px;"
            class="filter-item" placeholder="关键字" v-model="listQuery.keyWord"> </el-input>
          <el-button size="small" class="filter-item" type="primary" icon="search" @click="handleFilter">搜索</el-button>
        </div>
      </div>
    </template>

    <el-table :key='tableKey' :data="list" v-loading.body="listLoading" size="small" stripe highlight-current-row
      style="width: 100%">

      <el-table-column align="center" label="id" width="100">
        <template slot-scope="scope">
          <span>{{ scope.row.id }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="批次号">
        <template slot-scope="scope">
          <span>{{ scope.row.batchId }}</span>
        </template>
      </el-table-column>

      <el-table-column width="200px" align="center" label="原告名称">
        <template slot-scope="scope">
          <span>{{ scope.row.plaintiffName }}</span>
        </template>
      </el-table-column>
      <el-table-column width="200px" align="center" label="被告名称">
        <template slot-scope="scope">
          <span>{{ scope.row.defendantName }}</span>
        </template>
      </el-table-column>

      <el-table-column width="200px" align="center" label="委托日期">
        <template slot-scope="scope">
          <span>{{ scope.row.entrustmentDate }}</span>
        </template>
      </el-table-column>


      <el-table-column width="230px" align="center" label="删除日期">
        <template slot-scope="scope">
          <span>{{ scope.row.editTime }}</span>
        </template>
      </el-table-column>

      <el-table-column fixed="right" align="center" label="操作" width="150"> <template slot-scope="scope">
          <el-button v-permission:function="['recycleBin_btn_Recover']" size="small" type="success"
            @click="recoverCaseInfo(scope.row.id)">恢复</el-button>
        </template> </el-table-column>
    </el-table>
    <template slot="footer">
      <div v-show="!listLoading" class="pagination-container">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page.sync="listQuery.page" :page-sizes="[10, 20, 30, 50]" :page-size="listQuery.limit"
          layout="total, sizes, prev, pager, next, jumper" :total="total"> </el-pagination>
      </div>
    </template>

  </d2-container>
</template>

<script>
import {
  page, recoverCase
} from "@/api/czManager/recycleBin/index";
import { mapGetters } from 'vuex';
export default {
  name: 'czCaseInfo',
  data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        keyWord: undefined
      },
      textMap: {
        update: '编辑',
        create: '创建'
      },
      tableKey: 0
    }
  },
  created() {
    this.getList();
  },
  computed: {
    ...mapGetters([
      'elements'
    ])
  },
  methods: {
    getList() {
      this.listLoading = true;
      page(this.listQuery).then(response => {
        this.list = response.records;
        this.total = response.total;
        this.listLoading = false;
      })
    },
    /**
     * 恢复
     */
    recoverCaseInfo(id) {
      this.$confirm("是否恢复?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", }).then((res) => {
        recoverCase(id).then(res => {
          if (res.statusCode == 2000) {
            this.$message.success(res.message);
            this.getList()
          } else {
            this.$message.error("失败")
          }
        })

      });

    },
    handleFilter() {
      this.getList();
    },
    handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleCreate() {
      this.resetTemp();
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
    },


    cancel(formName) {
      this.dialogFormVisible = false;
      const set = this.$refs;
      set[formName].resetFields();
    },


  }
}
</script>
